import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

// Create a factory function that returns a ResellingService instance
export default function createResellingService(baseUrl: string, productCode: string) {
  // Configure request setup
  const serviceName = 'ResellingService'
  const host = baseUrl
  const opts: CustomAxiosHeaders = { host, serviceName }
  const request = (addlOpts?: CustomAxiosHeaders) => {
    return requests(Object.assign({}, opts, addlOpts))
  }

  // Helper function to handle response
  const responseBody = (res: AxiosResponse) => res.data

  // Return an object with the same methods as the original class
  return {
    productCode,

    getProductConfiguration: () =>
      request().get(`/product?productCode=${productCode}`).then(responseBody),

    getCompanyResellingConfiguration: (companyId: string) =>
      request().get(`/configuration/company/${companyId}/${productCode}`).then(responseBody),

    updateCompanyResellingConfiguration: (
      companyId: string,
      data: { amount?: number; offeringEnabled?: boolean }
    ) =>
      request().put(`/configuration/company/${companyId}/${productCode}`, data).then(responseBody),

    getLocationResellingConfiguration: (locationId: string) =>
      request().get(`/configuration/location/${locationId}/${productCode}`).then(responseBody),

    getLocationSubscriptions: (locationId: string) =>
      request().get(`/subscription/location/${locationId}?productCode=${productCode}`).then(responseBody),

    updateLocationResellingConfiguration: (
      locationId: string,
      data: { amount?: number; offeringEnabled?: boolean }
    ) =>
      request().put(`/configuration/location/${locationId}/${productCode}`, data).then(responseBody),

    agencyDirectPurchase: (locationId: string) =>
      request().post(`/subscription/location/${locationId}/${productCode}`, {
        purchaseStyle: 'COMPANY_DIRECT_PURCHASE',
      }).then(responseBody),

    agencyDirectPurchaseV2: (locationId: string, planId: string, affiliatePayload: any) =>
      request().post(`/subscription/location/${locationId}/${productCode}`, {
        planId: planId,
        purchaseStyle: 'COMPANY_DIRECT_PURCHASE',
        ...affiliatePayload
      }).then(responseBody),

    getCompanySubscriptions: (companyId: string) =>
      request().get(`/subscription/company/${companyId}`).then(responseBody)
  }
}